<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4F6YBh/tc-custom/9781429941655.jpg?1720009287813" alt="This image is the cover for the book Warrior Police"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Warrior Police
      </h1>
      <p class="bookDescription body article font2">
        <p><b>For the first time ever, author Gordon Cucullu gives readers an explosive inside look at modern military police units and their role in defending our freedom.</b><br/><br/>America has been at war on several fronts since the 9/11 attack. While public attention has focused on Marines, conventional Army units, and Special Operations Forces, a lion's share of the war-fighting has been done, under media radar, by Military Police units. These squad and platoon-sized units patrol dangerous urban streets, build up local police units to improve neighborhood stability, and conduct civic action missions. On many occasions they have rushed into a vicious firefight to come to the assistance of infantry units in desperate straits. They keep villages Taliban-free, monitor balloting sites, and interdict drug shipments. In detention centers at Camp Bucha, Iraq, Bagram, Afghanistan, and Guantanamo, Cuba they guard some of the most dangerous terrorists in history.<br/><br/>The story is told by the soldiers themselves, recounting what they have seen and experienced, along with historical context and first-hand field observations by the author team who were provided with unique inside access. <i>Warrior Police</i> takes readers into the bloody streets of Iraq, the dangerous back-country of Afghanistan, and wherever our Military Police are needed.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gordon Cucullu, Chris Fontana
      </h2>
      
      <p class="authorDescription body article"><P>Lieutenant Colonel (RET.) GORDON CUCULLU is a former Special Forces lieutenant colonel who saw combat in Vietnam and El Salvador. The author of two prior books, he was embedded with US Soldiers in Iraq in 2008 and twice in Afghanistan in 2010. He lives in Florida.<br><br>CHRIS FONTANA is a researcher and analyst on terrorism issues and the primary researcher for their book, Inside Gitmo. She was embedded with US forces in Afghanistan twice.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5d2932f0